import { AlertStatus } from '@/gen/inventory/v1/alert_pb'

import { alertStatusLabel } from '@/const/label'

import { cn } from '@/lib/ui/style-helpers'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { AlertStatusIcon } from '@/components/shared/icons/alert-status'

interface AlertStatusBadgeProps {
  status: AlertStatus
}

const alertStatusToTextClassName: Record<AlertStatus, string> = {
  [AlertStatus.OPEN]: 'text-main-foreground-danger',
  [AlertStatus.ONGOING]: 'text-main-foreground-secondary',
  [AlertStatus.RESOLVED]: 'text-main-foreground-success',
  [AlertStatus.ACCEPTED]: 'text-main-foreground-secondary',
  [AlertStatus.NOT_APPLICABLE]: 'text-main-foreground-secondary',
  [AlertStatus.UNSPECIFIED]: '',
}
export const AlertStatusBadge = ({ status }: AlertStatusBadgeProps) => (
  <Badge
    variant='outline'
    textCase='title'
    className={cn(
      'flex w-fit items-center gap-1 whitespace-nowrap border-none text-label-small',
      alertStatusToTextClassName[status],
    )}
  >
    <AlertStatusIcon status={status} />
    {alertStatusLabel[status]}
  </Badge>
)
